import { makePipelinesFetchKey, makePipelinesFetchUrl } from './cacheKeys';
import { withQuickFetch } from './withQuickFetch';
export const fetchPipelines = ({
  httpClient,
  frameworkTypeIdentifier
}) => withQuickFetch({
  requestName: makePipelinesFetchKey({
    frameworkTypeIdentifier
  }),
  baseFetch: () => httpClient.get(makePipelinesFetchUrl({
    frameworkTypeIdentifier
  }))
});